import getAuthData from "core/helpers/auth/getAuthData";

const authInitialState = {
	user: getAuthData() || null,
	lastLoggedInUserName: null,
	lockData: null
};

export default authInitialState;